// Route error boundary rendering problem details as a localized message (api-conventions spec).
import { Container, Text, errorMessage, useTranslation } from "@manapp/ui"
import { useEffect } from "react"
import { useRouteError } from "react-router-dom"

import { isProblem } from "../api"

export function ProblemBoundary() {
  const error = useRouteError()
  useEffect(() => {
    // Unexpected (non-API) errors are logged so they reach the browser console and error tracking.
    if (!isProblem(error)) console.error("route error", error)
  }, [error])
  return <ProblemView error={error} />
}

export function ProblemView({ error }: { error: unknown }) {
  const { t } = useTranslation()
  const code = isProblem(error) ? error.code : "internal.error"
  const title = isProblem(error) ? error.title : undefined
  return (
    <Container role="alert">
      <Text>{errorMessage(t, code, title)}</Text>
      {isProblem(error) && error.correlation_id ? (
        <Text size="xsmall" className="text-ui-fg-muted">
          {error.correlation_id}
        </Text>
      ) : null}
    </Container>
  )
}
